import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import '../../styles/no-sign-in.less';
import TechSmithLogo from '../../img/techsmith-logo.svg';
import { useTranslation } from 'react-i18next';
const CamtasiaNoSignIn = () => {
    const { t } = useTranslation();
    useEffect(() => {
        document.title = t('noSignIn.camtasiaPageTitle');
    }, []);
    return (_jsx("div", Object.assign({ className: "no-sign-in-container" }, { children: _jsxs("div", Object.assign({ className: "content-main" }, { children: [_jsx(TechSmithLogo, {}), _jsx("div", { children: _jsx("section", Object.assign({ id: "noSignInMessage", className: "content" }, { children: _jsxs("section", Object.assign({ className: "content-messaging" }, { children: [_jsx("p", { children: t('noSignIn.camtasiaMessage') }), _jsxs("p", { children: [_jsx("a", Object.assign({ href: t('noSignIn.camtasiaUpgradeLink') }, { children: t('noSignIn.upgradeText') })), t('noSignIn.or'), _jsx("a", Object.assign({ href: t('noSignIn.supportLink') }, { children: t('noSignIn.supportText') }))] })] })) })) })] })) })));
};
export default CamtasiaNoSignIn;
